import { Component, OnInit, Input } from '@angular/core';
import { OrderByPipe } from './../../../../shared/pipe/order-by.pipe';
import { EmployeeService } from '../../../../pages/employee/services/employee.service';
import { PortalSettingsService } from '../../../../core/services/portal-settings.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../../../core/services/utility.service';

@Component({
  selector: 'app-send-reminder-expense-modal',
  templateUrl: './send-reminder-expense-modal.component.html',
  styleUrls: ['./send-reminder-expense-modal.component.css']
})
export class SendReminderExpenseModalComponent implements OnInit {
  @Input() prco: any;
  portalSettings: any;
  counter: number;
  ReminderEmailList: any;
  orderByPipe: any;
  filterBy: any;
  reverse: boolean;

  constructor(private employeeService: EmployeeService, public activeModal: NgbActiveModal, portalSettingsService: PortalSettingsService, private utilityService: UtilityService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.orderByPipe = new OrderByPipe();
    this.employeeService.getUnSubmittedExpenseReminder(false, this.prco).then((response: any) => {
      this.ReminderEmailList = [];
      response.forEach((val: any, key) => {
        if (val != null)
          this.ReminderEmailList.push(val);
      })

      if (this.ReminderEmailList != null) {
        this.ReminderEmailList = this.orderByPipe.transform(this.ReminderEmailList, "FirstName", this.reverse ? "asc" : "desc");
        this.counter = this.ReminderEmailList.length;
      }
    })
  }

  public reminderClicked() {
    this.utilityService.openModal();
    this.employeeService.getUnSubmittedExpenseReminder(true, this.prco).then((response: any) => {
      this.utilityService.closeModal();
      this.activeModal.close();
    });
  }

  public cancelClicked() {
    this.activeModal.dismiss();
  }

  public sortGridReminder(filterBy) {
    if (this.filterBy != filterBy) {
      this.filterBy = filterBy;
      this.reverse = false;
    } else {
      this.reverse = !this.reverse;
    }
    this.ReminderEmailList = this.orderByPipe.transform(this.ReminderEmailList, filterBy, this.reverse ? "asc" : "desc");
  }
}
